import styled from 'styled-components';

const Checkmark = styled.span`
  position: absolute;
  top: 5px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border: 2px solid #8F8F8F;
  border-radius: 3px;
  &:after {
    content: "";
    position: absolute;
    display: none;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;
const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &:hover input ~ ${Checkmark} {
    background-color: #ccc;
  }
  & input:checked ~ ${Checkmark} {
    background: #5ED96A;
    border:none;
  }
  & input:checked ~ ${Checkmark}:after {
    display: block;
  }
  & ${Checkmark}:after {
    left: 8px;
    top: 1px;
    width: 5px;
    height: 15px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
export { Checkmark, Label };